import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/** Wire shape of one entry of `GET …/transcript/speakers` (§8.2). */
export type TranscriptSpeakerPayload = {
	readonly id: number;
	readonly label: string;
	readonly kind: LabeledValuePayload;
	readonly displayName: string | null;
	readonly contact: { readonly id: number } | null;
	readonly turnCount: number;
	readonly sampleText: string | null;
	readonly roleKey?: string | null;
	readonly roleLabel?: string | null;
};

export type TranscriptSpeakersFetchedAction = {
	type: 'TRANSCRIPT_SPEAKERS_FETCHED';
	// The route answers a bare array, never `{ totalRecords, results }` (§8.4): a transcript carries a
	// handful of speakers, never paginated.
	payload: TranscriptSpeakerPayload[];
	interviewId: number;
};

export default (
	payload: TranscriptSpeakerPayload[],
	interviewId: number,
): TranscriptSpeakersFetchedAction => ({
	type: 'TRANSCRIPT_SPEAKERS_FETCHED',
	payload,
	interviewId,
});
